
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel/review/[id]",
      function () {
        return require("private-next-pages/hotel/review/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotel/review/[id]"])
      });
    }
  